import { Typography } from '@customink/pigment-react';
import type { ProjectItem } from '@customink/project-service-react-components';
import { useDesign } from '@customink/project-service-react-components';

import { spacing8 } from '@/utils/designTokens';

type PersonalizationCountInfoProps = {
  item: ProjectItem;
};

export default function PersonalizationCountInfo({
  item,
}: PersonalizationCountInfoProps) {
  const { data: designData } = useDesign(item.design?.cid || '');
  const personalization = designData?.personalization || [];

  const totalQuantity = item.totalQuantity;

  const namesCount =
    personalization.map((p) => p.name).filter((v) => v !== undefined).length ??
    0;
  const numbersCount =
    personalization.map((p) => p.number).filter((v) => v !== undefined)
      .length ?? 0;

  const hasPersonalizationCountProblem =
    (namesCount > 0 && namesCount != totalQuantity) ||
    (numbersCount > 0 && numbersCount != totalQuantity);

  if (namesCount == 0 && numbersCount == 0) {
    return null;
  }

  return (
    <>
      <Typography
        component="p"
        data-testid="personalization-count-info"
        mt={spacing8}
        variant="uiTextSmall"
      >
        {namesCount} Name{namesCount === 1 ? '' : 's'}, {numbersCount} Number
        {numbersCount === 1 ? '' : 's'}
      </Typography>
      {!!hasPersonalizationCountProblem && (
        <Typography
          component="p"
          data-testid="personalization-count-warning"
          maxWidth={440}
          variant="paragraphTiny"
        >
          Not all of the items in your order have Names and Numbers specified.
          Please ensure this is what you intended:
          <br />
          <b>{totalQuantity} items</b> total, <b>{namesCount}</b> with Name
          {namesCount === 1 ? '' : 's'}, <b>{numbersCount}</b> with Number
          {numbersCount === 1 ? '' : 's'}
        </Typography>
      )}
    </>
  );
}
